import { get } from '@core/api/baseApi';

const getPrintableReport = async (studyInstanceUid: string, sopInstanceUid: string): Promise<Blob> =>
  await get<Blob>(`/studies/${studyInstanceUid}/reports/${sopInstanceUid}/print`, {
    responseType: 'blob'
  });

export default getPrintableReport;
